// removed by extract-text-webpack-plugin
module.exports = {"link":"_2p836","root":"_3mIlg","author":"_1lg18","itemName":"_1wMG_","category":"_22zJ2"};